import Colors from '../../constants/Colors'

export const TAB_MENUS = {
  OPEN: 'รอแจ้งโอน',
  CONFIRMED: 'แจ้งโอนแล้ว',
  SUCCESS: 'ซื้อสำเร็จ',
  CANCEL: 'ยกเลิกคำสั่งซื้อ',
}
export const MENU_3 = {
  LOCKED: 'ล็อค',
  ISSUE: 'มีปัญหา',
  // SEARCH: 'ค้นหา',
}
export const TITLE_MENUS = {
  OPEN: 'รอแจ้งโอน',
  CONFIRMED: 'แจ้งโอนแล้ว',
  SUCCESS: 'ซื้อสำเร็จ',
  CANCEL: 'ยกเลิกคำสั่งซื้อ',
  SEARCH: 'ออเดอร์ทั้งหมด',
  ISSUE: 'มีปัญหา',
  LOCKED: 'ออเดอร์ที่คุณล็อคไว้',
}
export const TAB_MENU_SLIPS = ['ALL', 'BAD_SLIP', 'REJECTED']
export const OBJ_BG_COLORS = {
  OPEN: Colors.BLUE,
  CONFIRMED: Colors.ORANGE,
  SUCCESS: Colors.GREEN,
  CANCEL: Colors.LIGHT_RED,
  SEARCH: Colors.DARK_GREY,
  ISSUE: Colors.LIGHT_RED,
  LOCKED: Colors.ORANGE,
}
export const CANCEL_REASON = [
  'ไม่แนบสลิป',
  'รูปที่แนบไม่ใช่สลิป',
  'สลิปซ้ำ',
  'ยอดเงินไม่ตรง',
  'สลิปปลอม',
  'บัญชีไม่ตรง',
  'ไม่สามารถตรวจสอบรายการได้',
  'ลูกค้ายกเลิก',
  'ปิดงวด',
  'อื่นๆ',
]
export const STATUS = {
  OPEN: 'รอแจ้งโอน',
  CONFIRMED: 'แจ้งโอนแล้ว',
  SUCCESS: 'ซื้อสำเร็จ',
  CANCEL: 'ยกเลิก',
}
